export const POLL = "poll"
export const RECOGNITION = "recognition"
export const REWARD = "reward"
